import styled, { css } from 'styled-components';
import { SectionHeading, HighlightText } from '../../global/typography';

export const StyledSection = styled.section`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5rem 0;
    flex-direction: column;

    @media (max-width: 979px) {
        padding: 3.125rem 0;
    }
`;

export const StyledContainer = styled.div<{ $flex: 'row' | 'column' }>`
    display: flex;
    gap: 50px;

    ${props =>
        props.$flex === 'row' &&
        css`
            flex-direction: row;

            @media (max-width: 979px) {
                flex-direction: column;
            }
        `}

    ${props =>
        props.$flex === 'column' &&
        css`
            flex-direction: column;
        `}

  @media (max-width: 979px) {
        gap: 35px;
    }
`;

export const StyledHeading = styled(SectionHeading)`
    text-align: center;
    margin-bottom: 0.94rem;

    & > span.--green {
        color: ${props => props.theme.colors.primary};
        display: block;
    }
`;

export const StyledHeadingSpan = styled(SectionHeading)`
    display: block;
`;

export const StyledHighlight = styled(HighlightText)`
    text-align: center;

    span {
        color: ${props => props.theme.colors.primary};
    }
`;

export const StyledLink = styled.a`
    font-size: 28px;
    line-height: 42px;
    font-weight: 600;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
    color: black;

    &:hover {
        text-decoration: none;
        color: black;
    }
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 3.125rem;
`;
